import c from '@/styles/BylineGroup';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';

export interface BylineGroupProps extends ComponentProps<'div'> {
  variant?: ClassNameProp<'horizontal' | 'vertical'>;
}

export const BylineGroup: Component<BylineGroupProps> = ({ className, variant, children, ...props }) => {
  const getPropStyles = getPropStylesFactory(c);

  const variantClassName = getPropStyles('variant', variant, 'horizontal');
  const componentClassName = cn(variantClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};
